module.exports = __webpack_public_path__ + "static/img/1-2.7e057ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202109/1-2.png
// module id = 4hhg
// module chunks = 0